import BUtil from './b_util';

const white = hsl2rgb(0, 0, 1.0)
const light = hsl2rgb(0, 0, 0.75)
const gray = hsl2rgb(0, 0, 0.5)
const dark = hsl2rgb(0, 0, 0.25)
const black = hsl2rgb(0, 0, 0)

const extreme_light_orange = hsl2rgb(30, 1, 0.8)
const light_orange = hsl2rgb(30, 1, 0.65)
const orange = hsl2rgb(30, 1, 0.5)
const dark_orange = hsl2rgb(30, 1, 0.35)
const extreme_dark_orange = hsl2rgb(30, 1, 0.2)

const extreme_light_red = hsl2rgb(0, 1, 0.8)
const extreme_light_yellow = hsl2rgb(60, 1, 0.8)
const extreme_light_green = hsl2rgb(120, 1, 0.8)
const extreme_light_cyan = hsl2rgb(180, 1, 0.8)
const extreme_light_blue = hsl2rgb(240, 1, 0.8)
const extreme_light_purple = hsl2rgb(300, 1, 0.8)

const light_red = hsl2rgb(0, 1, 0.65)
const light_yellow = hsl2rgb(60, 1, 0.65)
const light_green = hsl2rgb(120, 1, 0.65)
const light_cyan = hsl2rgb(180, 1, 0.65)
const light_blue = hsl2rgb(240, 1, 0.65)
const light_purple = hsl2rgb(300, 1, 0.65)

const red = hsl2rgb(0, 1, 0.5)
const yellow = hsl2rgb(60, 1, 0.5)
const green = hsl2rgb(120, 1, 0.5)
const cyan = hsl2rgb(180, 1, 0.5)
const blue = hsl2rgb(240, 1, 0.5)
const purple = hsl2rgb(300, 1, 0.5)

const dark_red = hsl2rgb(0, 1, 0.35)
const dark_yellow = hsl2rgb(60, 1, 0.35)
const dark_green = hsl2rgb(120, 1, 0.35)
const dark_cyan = hsl2rgb(180, 1, 0.35)
const dark_blue = hsl2rgb(240, 1, 0.35)
const dark_purple = hsl2rgb(300, 1, 0.35)

const extreme_dark_red = hsl2rgb(0, 1, 0.2)
const extreme_dark_yellow = hsl2rgb(60, 1, 0.2)
const extreme_dark_green = hsl2rgb(120, 1, 0.2)
const extreme_dark_cyan = hsl2rgb(180, 1, 0.2)
const extreme_dark_blue = hsl2rgb(240, 1, 0.2)
const extreme_dark_purple = hsl2rgb(300, 1, 0.2)

const primary = blue
const secondary = gray
const success = green
const info = cyan
const warning = yellow
const danger = red

const default_color = white
const default_background_color = black

function hex2rgb (hex_str) {
  let arr = []

  hex_str = hex_str.replace("#", "")
  arr[0] = hex_str.substring(0, 2)
  arr[1] = hex_str.substring(2, 4)
  arr[2] = hex_str.substring(4, 6)

  return arr
}

function hsl2rgb (h0, s, l) {
  // h0输入的h范围为[0,360],s,l为百分比形式的数值,范围是[0,1]
  // 输出r,g,b范围为[0,255],可根据需求做相应调整
  let h = h0 / 360;
  // var s = s / 100;
  // var l = l / 100;
  let rgb = [];

  if (s == 0) {
    rgb = [Math.round(l * 255), Math.round(l * 255), Math.round(l * 255)];
  } else {
    var q = l >= 0.5 ? (l + s - l * s) : (l * (1 + s));
    var p = 2 * l - q;
    var tr = rgb[0] = h + 1 / 3;
    var tg = rgb[1] = h;
    var tb = rgb[2] = h - 1 / 3;
    for (var i = 0; i < rgb.length; i++) {
      var tc = rgb[i];
      // console.log(tc);
      if (tc < 0) {
        tc = tc + 1;
      } else if (tc > 1) {
        tc = tc - 1;
      }
      switch (true) {
        case (tc < (1 / 6)):
          tc = p + (q - p) * 6 * tc;
          break;
        case ((1 / 6) <= tc && tc < 0.5):
          tc = q;
          break;
        case (0.5 <= tc && tc < (2 / 3)):
          tc = p + (q - p) * (4 - 6 * tc);
          break;
        default:
          tc = p;
          break;
      }
      rgb[i] = Math.round(tc * 255);
    }
  }

  return rgb
}

export default class BColor {
  static WHITE = white
  static LIGHT = light
  static GRAY = gray
  static DARK = dark
  static BLACK = black


  static EXTREME_LIGHT_ORANGE = extreme_light_orange
  static LIGHT_ORANGE = light_orange
  static ORANGE = orange
  static DARK_ORANGE = dark_orange
  static EXTREME_DARK_ORANGE = extreme_dark_orange

  static EXTREME_LIGHT_RED = extreme_light_red
  static EXTREME_LIGHT_YELLOW = extreme_light_yellow
  static EXTREME_LIGHT_GREEN = extreme_light_green
  static EXTREME_LIGHT_CYAN = extreme_light_cyan
  static EXTREME_LIGHT_BLUE = extreme_light_blue
  static EXTREME_LIGHT_PURPLE = extreme_light_purple

  static LIGHT_RED = light_red
  static LIGHT_YELLOW = light_yellow
  static LIGHT_GREEN = light_green
  static LIGHT_CYAN = light_cyan
  static LIGHT_BLUE = light_blue
  static LIGHT_PURPLE = light_purple

  static RED = red
  static YELLOW = yellow
  static GREEN = green
  static CYAN = cyan
  static BLUE = blue
  static PURPLE = purple

  static DARK_RED = dark_red
  static DARK_YELLOW = dark_yellow
  static DARK_GREEN = dark_green
  static DARK_CYAN = dark_cyan
  static DARK_BLUE = dark_blue
  static DARK_PURPLE = dark_purple

  static EXTREME_DARK_RED = extreme_dark_red
  static EXTREME_DARK_YELLOW = extreme_dark_yellow
  static EXTREME_DARK_GREEN = extreme_dark_green
  static EXTREME_DARK_CYAN = extreme_dark_cyan
  static EXTREME_DARK_BLUE = extreme_dark_blue
  static EXTREME_DARK_PURPLE = extreme_dark_purple

  static get_random_color () {
    let r = BUtil.getRandomNumber(63, 255)
    let g = BUtil.getRandomNumber(63, 255)
    let b = BUtil.getRandomNumber(63, 255)

    return [r, g, b]
  }

  static get_random_color () {
    let r = BUtil.getRandomNumber(63, 255)
    let g = BUtil.getRandomNumber(63, 255)
    let b = BUtil.getRandomNumber(63, 255)

    return [r, g, b]
  }

  static hsl2rgb (h, s, l) {
    return hsl2rgb(h, s, l)
  }

  static getRainbowColor (index, lightness) {
    let l = 0.5
    if (lightness) {
      l = lightness
    }
    let rcs = [0, 30, 60, 120, 180, 208, 300]
    if (index >= rcs.length) {
      index = 0
    }
    let c = BColor.hsl2rgb(rcs[index], 1, l)
    return c
  }

  static getRainbowColorsLength () {
    return 7
  }

  static getRainbowColorFormatRGB (index, lightness) {
    let c = BColor.getRainbowColor(index, lightness)
    return `rgb(${c[0]}, ${c[1]}, ${c[2]})`
  }
}


